//
// Module for the Generate Schedules wizard Settings step
//
rs.module("jobs/criteria/generateschedules/settingsstep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, config) {

            var stepContainer = $.js(jsSelectors.stepContainer);

            var durationSelect = stepContainer.js(jsSelectors.durationSelect);
            var endByDate = stepContainer.js(jsSelectors.endByDate);

            durationSelect.change(function () {
                var disable = this.value != config.duration.specifyEndDate;

                if (disable) {
                    endByDate.val(null).clearErrors();
                }

                endByDate.prop("disabled", disable);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);